import { render, staticRenderFns } from "./folders-sort-by.vue?vue&type=template&id=7a7ff9c6&scoped=true"
import script from "./folders-sort-by.vue?vue&type=script&lang=js"
export * from "./folders-sort-by.vue?vue&type=script&lang=js"
import style0 from "./folders-sort-by.vue?vue&type=style&index=0&id=7a7ff9c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a7ff9c6",
  null
  
)

export default component.exports